import makeStyles from "@mui/styles/makeStyles";
import { InfiniteListProps } from "./InfiniteList.types";

export const useStyles = makeStyles((theme) => ({
  root: (props: InfiniteListProps<any>) => ({
    width: props.width,
    height: props.height,
  }),
  list: {
    scrollbarColor: "#aaa transparent",
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      width: 4,
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: theme.palette.grey[500],
    },
    "& > ul": {
      listStyle: "none",
      margin: 0,
      padding: 0,
    },
  },
}));
